import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-pastry',
  templateUrl: './icon-pastry.component.html',
  styleUrls: ['./icon-pastry.component.scss']
})
export class IconPastryComponent implements OnInit {

  @Input() cssClass = 'icon--18';
  
  constructor() { }

  ngOnInit() {
  }

}
